<template>
  <div>
    <div class="row">
      <div class="col">
        <span class="search-header">{{ $t("pages.payroll.searching_header") }}</span>
        <img src="@/assets/IC_Minimise.png" alt="min" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <form>
          <div class="form-row">
            <div class="col-md-6">
              <department-list-field id="department" name="department" :form="form" />
            </div>
            <div class="col-md-6">
              <establishment-list-field id="establishment" name="establishment" :form="form" />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <employee-list-field
                id="employee-code"
                name="employeeCode"
                :form="form"
                :department-code="selectedDepartmentCode"
                :establishment-code="selectedEstablishmentCode"
              />
            </div>
            <div class="col-md-6">
              <appointment-status-field id="status" name="status" :form="form" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <a href="#" class="mx-4 search-clean" @click.prevent="clear">{{
          $t("components.actions.clear")
        }}</a>
        <vue-button
          :title="$t('components.actions.search')"
          class="btn-primary search-button"
          @click="searchClicked"
        ></vue-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EmployeeListField,
  AppointmentStatusField,
  DepartmentListField,
  EstablishmentListField,
} from "@/pages/components/fields";
import { VueButton, Form, Options } from "@/components/form";

import { SUC_SELECT_CHANGED_EVENT } from "@/components/form";
import { ABSENCES_SEARCH_CHANGED_EVENT } from "./index";

export default {
  components: {
    EmployeeListField,
    VueButton,
    AppointmentStatusField,
    DepartmentListField,
    EstablishmentListField,
  },
  data() {
    return {
      form: new Form({
        data: {
          status: null,
          employeeCode: null,
          department: null,
          establishment: null,
        },
        options: {
          ...new Options().add("employeeCode", "employeeCode"),
          ...new Options().add("department", "departmentCode"),
          ...new Options().add("establishment", "establishmentCode"),
          ...new Options().add("status", "id"),
        },
      }),
    };
  },
  computed: {
    selectChangeEvent() {
      return SUC_SELECT_CHANGED_EVENT;
    },
    selectedDepartmentCode() {
      const dept = this.form.data().department;
      console.log("Absences - department data:", dept);
      return dept || null;
    },
    selectedEstablishmentCode() {
      const est = this.form.data().establishment;
      console.log("Absences - establishment data:", est);
      return est || null;
    },
  },
  methods: {
    init() {},
    clear() {
      this.form.reset();
      EventBus.fire(ABSENCES_SEARCH_CHANGED_EVENT, {
        status: null,
        employeeCode: null,
        department: null,
        establishment: null,
      });
    },
    searchClicked() {
      let data = this.form.data();
      console.log("=== ABSENCES FORM SUBMIT ===");
      console.log("Form data:", data);
      console.log("Selected employee:", data.employeeCode);
      console.log("Selected department:", data.department);
      console.log("Selected establishment:", data.establishment);
      console.log("Selected status:", data.status);
      EventBus.fire(ABSENCES_SEARCH_CHANGED_EVENT, data);
    },
  },
};
</script>

<style lang="scss" scoped>
.payroll-action {
  padding-left: 5px;
  color: var(--portal-primary);

  & > img {
    margin-right: 5px;
  }
}

.search-header {
  color: var(--portal-secondary);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22.4px;
  margin-right: 5px;
}

.search-button {
  border-radius: $border-radius;
  height: 50px;
  width: 125px;
}

.search-clean {
  color: var(--portal-text-muted) !important;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none !important;

  &:hover {
    color: var(--portal-text) !important;
  }
}
</style>
